<template>
  <Dialog
      id="remove-group-modal"
      v-model:visible="visible"
      :header="t('REMOVE_GROUP_TITLE', { name: group?.title })"
      modal
      :draggable="false"
      :dismissable-mask="true"
      @hide="resetModal"
  >
    <p>{{ t("REMOVE_GROUP_CONFIRM_MSG") }}</p>

    <template #footer>
      <Button :label="t('CANCEL')" severity="secondary" @click="visible = false"/>
      <Button :label="t('REMOVE')" severity="danger" :loading="isLoading" @click="handleOk"/>
    </template>
  </Dialog>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import EventBus from "@/util/eventBus";
import {useToast} from "@/util/toastUtils";

const axios = injectAxios();
const {t} = useI18n();
const toast = useToast();

const visible = ref(false);
const group = ref(null);
const isLoading = ref(false);
const emit = defineEmits(["group-removed"]);

function showModal(g) {
  group.value = g;
  visible.value = true;
}

function resetModal() {
  group.value = null;
  isLoading.value = false;
  visible.value = false;
}

async function handleOk(ev) {
  ev.preventDefault();

  if (!group.value) {
    return
  }

  isLoading.value = true;

  try {
    await axios.delete(`/training/group/${group.value.id}`);
    toast.makeSuccessToast(t("REMOVED_GROUP"));
    emit("group-removed", group.value.id);
    visible.value = false;
  } finally {
    isLoading.value = false;
  }
}

onMounted(() => {
  EventBus.$on("show-remove-group-modal", showModal);
});

onBeforeUnmount(() => {
  EventBus.$off("show-remove-group-modal", showModal);
});
</script>
